/**
 * A regex object to validate zip codes
 */
export const ZIP_CODE_REGEX = /^\d{5}(?:[-\s]\d{4})?$/;
